export default __webpack_public_path__ + "static/media/Wooden_Main.c7a7b69e.jpg";